import * as React from 'react';

import AuthContext from "../context/AuthContext";

import { useParams, useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

import AuthLayout, { TRUE_DARK, TRUE_MUTED, primaryButtonSx } from './auth/AuthLayout';

const baseUrl = process.env.REACT_APP_BASE_URL || '';


const AcceptInvite = () => {
    const navigate = useNavigate();
    const { code } = useParams<{ code: string }>();
    const { registerUserInvite } = React.useContext(AuthContext);

    const [organization, setOrganization] = React.useState<string>('');
    const [email, setEmail] = React.useState<string>('');

    React.useEffect(() => {
        const getInvite = async () => {
            const response = await fetch(`${baseUrl}/management/accept-invite/?invite_code=${code}`);
            if (response.status !== 200) {
                navigate("/login");
            };
            const data = await response.json();
            setOrganization(data.organization.name);
            setEmail(data.email);
        }
        getInvite();
    }, [code, navigate]);
    
    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const username = email
        const password = data.get('password')
        const confirmPassword = data.get('confirm_password')
        registerUserInvite(username, password, confirmPassword, code);
    };
    
    return (
        <AuthLayout
            title="Aceptar invitación"
            subtitle={organization ? <>Te invitaron a unirte a <strong style={{ color: TRUE_DARK }}>{organization}</strong></> : undefined}
        >
            <Box component="form" onSubmit={handleSubmit}>
                <Typography variant="body1" sx={{ fontWeight: 600, color: TRUE_DARK, fontFamily: 'Inter, sans-serif' }}>
                    {email}
                </Typography>
                <Typography variant="body2" sx={{ color: TRUE_MUTED, fontFamily: 'Inter, sans-serif', mb: 1 }}>
                    Tu correo electrónico será tu nombre de usuario. Elige una contraseña.
                </Typography>
                <TextField
                    fullWidth
                    margin="normal"
                    size="small"
                    label="Contraseña"
                    name="password"
                    required
                    type="password"
                    autoComplete="new-password"
                />
                <TextField
                    fullWidth
                    margin="normal"
                    size="small"
                    label="Confirmar contraseña"
                    name="confirm_password"
                    required
                    type="password"
                    autoComplete="new-password"
                    sx={{ mb: 3 }}
                />
                <Button fullWidth type="submit" variant="contained" sx={primaryButtonSx}>
                    Aceptar
                </Button>
            </Box>
        </AuthLayout>
    );
};

export default AcceptInvite;
